import { getAssetsPriceUsd } from "@services/index";
import { useQuery } from "@tanstack/react-query";
import { ETH, RSETH, WETH } from "@config/contractsConfig";

enum Assets {
  WETH = "weth",
  RSETH = "kelp-dao-restaked-eth",
  ETH = "ethereum",
}

interface CoinGeckoPriceResponse {
  [key: string]: { usd: number };
}

const usePrices = () => {
  const { data: prices, isLoading } = useQuery({
    queryKey: ["assets-price"],
    queryFn: async () => {
      const response = await getAssetsPriceUsd([
        Assets.RSETH,
        Assets.WETH,
        Assets.ETH,
      ]);
      return response.data as CoinGeckoPriceResponse;
    },
  });

  const assets = {
    [RSETH]: prices?.[Assets.RSETH] ?? null,
    [WETH]: prices?.[Assets.WETH] ?? null,
    [ETH]: prices?.[Assets.ETH] ?? null,
  };

  return {
    assets,
    isLoading,
  };
};

export default usePrices;
